module.exports = __webpack_public_path__ + "img/MTABAPP6MWT.2e1b5673.svg";